import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import BurgerListTabs from "@/components/menu-management/burger/burger-list/burger-list-tabs";
import DraftListTabs from "@/components/menu-management/burger/burger-list/draft-list-tabs";
import {
  fetchAllBurgers,
  clearBurgerMessages,
} from "@/redux/slice/menu-manage-slice/burger-slice";
import useAuth from "@/hooks/useAuth";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { clearItemVariants } from "@/redux/slice/essential-menu-slice/variants-slice";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import hasPermission from "@/hooks/hasPermission";

function Burger() {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { getLoading } = useSelector((state) => state.menuManage.burger);

  useEffect(() => {
    dispatch(fetchAllBurgers(user?.restaurant_id));
    dispatch(clearBurgerMessages());
    dispatch(clearItemVariants());
  }, [user?.restaurant_id]);

  if (getLoading) return <TableSkeleton links={backofficeLinks} />

  return (
    <Layout2
         pageName={{ title: "Burger List" }}
      paths={[
        { name: "home", path: "/home" },
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Menu Management", path: "/backoffice/menu/drinks" },
        { name: "Burger", path: "/backoffice/menu/burger" },
      ]}
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
    >
      <div className="container flex flex-col gap-4 mt-5">
        <div className="flex justify-end items-start md:items-center md:flex-row flex-col  w-full">
 
          {hasPermission("back_office.menu_management.create_burger") && (
            <Link to={"/backoffice/menu/burger/create"}>
              <Button>
                <Plus /> Create Burger
              </Button>
            </Link>
          )}
        </div>
        <Tabs valueKey="menu-burger" className="bg-transparent relative" defaultValue="drink">
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            <TabsTrigger className="bg-transparent" value="drink">
              Burger List
            </TabsTrigger>
            <TabsTrigger value="draft">Draft List</TabsTrigger>
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          <BurgerListTabs />
          <DraftListTabs />
        </Tabs>
      </div>
    </Layout2>
  );
}

export default Burger;
